import { createFileRoute } from '@tanstack/react-router'
import { SavedMapsTab } from '~/components/routes/development/real-estate/saved-maps/saved-maps-tab'
import { AREA_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/cartes-validees')({
  staticData: { permission: AREA_READ },
  beforeLoad: realEstateTabGuard('cartes-validees'),
  component: SavedMapsTab,
})
